import React, { useState } from 'react';
import OrangeButton from '../../Components/buttons/orange-button';
import { Modal } from '@mui/material';

const CollegeCounselingModal = ({ open, handleClose }) => {
  const [formdData, setFormdData] = useState({
    firstName: '',
    email: '',
  });
  //TODO Mason to collect email address
  const hanldeSubmit = (e) => {
    e.preventDefault();
  };
  return (
    <Modal
      open={open}
      onClose={handleClose} // Handles both backdrop clicks and ESC key press
      aria-labelledby="apply-as-tutor-modal"
      aria-describedby="apply-as-tutor-modal-description"
    >
      <div className="flex h-full w-full items-center justify-center" onClick={handleClose}>
        <div
          className="relative flex w-full max-w-md flex-col gap-2 rounded-[16px] bg-white p-4 shadow-lg"
          onClick={(e) => e.stopPropagation()} // Prevents modal content clicks from closing the modal
        >
          {/* <button onClick={handleClose} className="absolute right-3 top-2">
                        <Close />
                    </button> */}
          <h2 className="fredoka text-center text-[40px] font-medium leading-normal tracking-[-0.8px] text-[#012E33]">
            Book In-person counseling
          </h2>
          <form className="space-y-3" onSubmit={hanldeSubmit}>
            <div>
              <input
                type="text"
                id="firstName"
                placeholder="Enter Name"
                onChange={(e) => setFormdData({ ...formdData, firstName: e.target.value })}
                className="w-full rounded-[8px] border border-[#DCDCDC] bg-[#F5F5F5] p-3 outline-none"
              />
            </div>
            <div>
              <input
                type="email"
                id="email"
                placeholder="Enter Email"
                onChange={(e) => setFormdData({ ...formdData, email: e.target.value })}
                className="w-full rounded-[8px] border border-[#DCDCDC] bg-[#F5F5F5] p-3 outline-none"
              />
            </div>
            <OrangeButton label={'Submit'} className="w-full" />
          </form>
        </div>
      </div>
    </Modal>
  );
};

export default CollegeCounselingModal;
